import React, { useState,useEffect } from 'react';
import { axiosInstance } from "../axios/Axios";
import { useParams } from "react-router-dom";
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';

import { useCallback } from 'react';

import 'survey-core/defaultV2.min.css';
import { Model } from 'survey-core';
import { Survey } from 'survey-react-ui';


const Response = () => {

    const [showToast, setShowToast] = useState(false);
    const toggleShowToast = () => setShowToast(!showToast);

    const [msg, setMsg] = useState(null);
    const [subMsg, setSubMsg] = useState(null);


    const { gid } = useParams();

    const [data,setData] = useState(null);
    useEffect(() => {

        axiosInstance.get('survey/get/'+gid+'/')
            .then((res) => {
                if("format" in res.data)
                    setData(res.data.format)
                else
                    setData(res.data)
            })

    },[])

    const survey = new Model(data);
    const alertResults = useCallback((sender) => {
        const results = JSON.stringify(sender.data);
        var send = {"results":results,"gid":gid}
        axiosInstance.post('survey/response/',send)
            .then((res) => {
                if(res.data["msg"]=='success')
                {
                    setMsg("Successful");
                    setSubMsg("Survey response saved successfully");
                    toggleShowToast();
                }
                else
                {
                    setMsg("Failure");
                    setSubMsg("Please submit the response again, your results have been lost");
                    toggleShowToast();
                }
            })
    }, []);

    survey.onComplete.add(alertResults);

    
    if(data===null)
        return <p>Loading</p>

    if("msg" in data && data["msg"]==="error")
        return <div>Error</div>

    return <>
        <ToastContainer position="top-start" className="p-3">
            <Toast show={showToast} onClose={toggleShowToast}>
                <Toast.Header>
                    <strong className="me-auto">{msg}</strong>
                </Toast.Header>
                <Toast.Body>{subMsg}</Toast.Body>
            </Toast>
        </ToastContainer>
        <Survey model={survey} />;
    </>

}

export default Response
